import { Announcement } from "..";

/**
 * Check if an announcement is either created by the user or read by the user
 */
export default function checkIfUnread(ann: Announcement, uname: string) {
  const read = ann.readBy.includes(uname);
  const isAuthor = ann.author === uname;
  return !read && !isAuthor;
}